/* eslint-disable max-nested-callbacks */
import { cacheDecorator } from '@ds/swymkit/tools'
import type { PublicAPI_AMD } from '@ds/swymkit/typings'

import { swymFetch } from '~/services/fetch-swym'

import { requestIdleOrTimeoutCallback } from '~/features-generic/libs/utils/request-idle'

export function getUWPAppProperties() {
  return cacheDecorator(
    'uwp-app-properties',
    async () => {
      return swymFetch
        .get('/uwp/api/appProperties')
        .json<PublicAPI_AMD['applicationConfigurations']>()
      // Put application values into PublicAPI for later usage of AMD Modules
        .then((response) => {
          requestIdleOrTimeoutCallback(async () => {
            import('@3ds/common-preferences').then(async ({ Preferences, CommonEvents }) => {
              if (Preferences.isNativeApp() && Array.isArray(response)) {
                // HTP1: Force disable CORS in PublicAPI to force proxification in WAFData
                response.forEach((item) => {
                  if (item.propertyKey === 'com.3ds.wp.passport.cors')
                    item.propertyValue = 'disabled'
                })

                CommonEvents.emitEventToNativeApp(CommonEvents.EVENTS.NOTIFY_APP_UWP_PROPERTIES, response)
              }

              const { requirejsOne } = await import('@ds/swymkit/tools')
              const PublicAPI = await requirejsOne<PublicAPI_AMD>('DS/UWPClientCode/PublicAPI')

              PublicAPI.applicationConfigurations = response
            })
          })

          return response
        })
      // Parse application values to key/value pairs
        .then(response => Object.fromEntries(response.map(el => ([el.propertyKey, el.propertyValue]))))
    },
    3600000,
  )
} // cache for an hour

/**
 * Get the UWP App Property value from the provided App Property key.
 * Will fetch the entire App Properties list if not fetched yet.
 * @param key - UWP App Property key.
 * @returns Promise with UWP App Property value or undefined if app Property key not found.
 */
export async function getUWPAppProperty(key: string): Promise<string | undefined> {
  const properties = await getUWPAppProperties()
  return properties[key]
}
